import { activePage, type Page } from "./state/appState";

interface PageDefinition {
  id: Page;
  label: string;
}

// Adding a new tab/page = add an entry here + a conditional render in App.tsx.
export const PAGES: PageDefinition[] = [
  { id: "demand", label: "DEMAND" },
  { id: "ssm", label: "SSM" },
  { id: "kiosks", label: "KIOSKS" },
];

function pageFromHash(): Page {
  const hash = window.location.hash.replace("#", "");
  return PAGES.some((p) => p.id === hash) ? (hash as Page) : "demand";
}

export function initRouter() {
  activePage.value = pageFromHash();
  window.addEventListener("hashchange", () => {
    activePage.value = pageFromHash();
  });
}

export function navigateTo(page: Page) {
  window.location.hash = page;
}
